<div class="mct-justify-start mct-items-center mct-flex-1-1-100px">
  <action-button
    [label]="'common.actions' | translate | titlecase"
    [items]="actionsOptions"
    [menuStyle]="{ width: '325px', 'max-width': '85vw' }"
    data-cy="btnProfileSearchActions"
  >
  </action-button>
  <wl-busy></wl-busy>
</div>
